import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useRequestState } from '@app/hooks';
import { AddCandidatePage } from './add-candidate-page';
import { CandidateList } from './candidate-list';
import { useTable } from '@app/components/table';
import { getCandidates } from '../slice';
import { selectCandidateState } from '../selectors';

const CandidateListPage = () => {
  const tableProps = useTable();
  const dispatch = useDispatch();

  const [query, setQuery] = useState('');

  const addCandidateDialog = useDialog();

  const { data, loading } = useRequestState({
    stateSelector: selectCandidateState,
    errorShown: true,
  });

  const handleSearchChange = (event: any) => {
    setQuery(event.target.value);
  };

  useEffect(() => {
    if (query.length !== 0) {
      dispatch(getCandidates(query));
    } else {
      dispatch(getCandidates());
    }
  }, [dispatch, query]);

  return (
    <>
      <Header
        title={Strings.page_title.candidates}
        helperText={''}
        actionButtonTitle={Strings.button.addCandidate}
        onClickActionButton={addCandidateDialog.show}
        searchBarProps={{
          placeholder: Strings.common.idEmailSource,
          onChange: handleSearchChange,
        }}
      />
      <CandidateList loading={loading} tableProps={tableProps} rows={data} />
      {addCandidateDialog.visible && (
        <AddCandidatePage open={addCandidateDialog.visible} onClose={addCandidateDialog.hide} />
      )}
    </>
  );
};

export { CandidateListPage };
